import { render, staticRenderFns } from "./EvalPromptManagement.vue?vue&type=template&id=ebec1b92&scoped=true&"
import script from "./EvalPromptManagement.vue?vue&type=script&lang=js&"
export * from "./EvalPromptManagement.vue?vue&type=script&lang=js&"
import style0 from "./EvalPromptManagement.vue?vue&type=style&index=0&id=ebec1b92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebec1b92",
  null
  
)

export default component.exports